import { ArtistPhotoTag } from '@customTypes/types';

import { useShowFullArtistProfileQuery } from '@/features/work/api/show-full-artist-profile';
import { useArtistProfilePhotoListQuery } from '@/shared/api/requests';

type ArtistConditionPage = {
  profileId: string;
};

export const useArtistConditionView = ({ profileId }: ArtistConditionPage) => {
  const fullProfile = useShowFullArtistProfileQuery({ profileId });

  const profilePhoto = useArtistProfilePhotoListQuery({
    profileId,
    tag: ArtistPhotoTag.ProfilePhoto
  });

  const queries = [fullProfile, profilePhoto];
  const isLoading = queries.some((q) => q.isLoading);
  return {
    state: { isLoading, fullProfile, profilePhoto },
    functions: {}
  };
};
